import React, {} from 'react'
import {FormSaveResult,MetadataOption,AppFormFieldData,AppFormData} from 'api'
import {AppFormItemProps} from './AppFormItem'


export interface AppFormContextProps {
	formData: any
	mode?:number
	onChange?: (item: AppFormItemProps) => void
}

export const AppFormContext = React.createContext<AppFormContextProps>({} as AppFormContextProps) 



// WEBPACK FOOTER //
// ./src/qcc/AppForm/AppFormContext.tsx